/* ============================================================
   pd-p5-lite.js — minimalt p5-kompatibelt lag
   ============================================================
   Erstatter p5.js 1.7.0 (0,93 MB / 178 KB over nettet) for den ene
   animation i snippets/mm-hero-visual.liquid.

   Animationen bruger kun 2D-primitiver — ingen WebGL, ingen 3D,
   ingen billedbehandling, ingen lyd, ingen DOM-hjælpere. Dette lag
   implementerer præcis de funktioner sketchen kalder, oven på
   almindelig Canvas 2D, og efterligner p5's instance mode:

     new p5(function (p) { p.setup = ...; p.draw = ...; })

   Sketchen i mm-hero-visual.liquid er derfor UÆNDRET.

   To ting er bedre end i den rigtige p5:
   - devicePixelRatio kappes ved 2, saa 4K-skærme ikke tegner
     16 gange saa mange pixels som noedvendigt
   - animationen sættes paa pause naar canvas ikke er i billedet,
     i stedet for at koere videre resten af besoeget

   Mangler noget en dag? Tilfoej funktionen her — eller hent den
   rigtige p5 tilbage. API'et er det samme.
   ============================================================ */
(function () {
  'use strict';
  if (window.p5) return;

  /* ---------- farver ---------- */
  function parseColor(a) {
    if (a.length === 1) {
      var v = a[0];
      if (typeof v === 'string') {
        var s = v.trim();
        if (s.charAt(0) === '#') {
          if (s.length === 4) s = '#' + s[1] + s[1] + s[2] + s[2] + s[3] + s[3];
          return {
            r: parseInt(s.substr(1, 2), 16),
            g: parseInt(s.substr(3, 2), 16),
            b: parseInt(s.substr(5, 2), 16),
            a: 255
          };
        }
        return { r: 0, g: 0, b: 0, a: 255 };
      }
      if (v && typeof v === 'object' && 'r' in v) {
        return { r: v.r, g: v.g, b: v.b, a: 'a' in v ? v.a : 255 };
      }
      return { r: +v, g: +v, b: +v, a: 255 };           // gråtone
    }
    if (a.length === 2) { var g = +a[0]; return { r: g, g: g, b: g, a: +a[1] }; }
    return { r: +a[0], g: +a[1], b: +a[2], a: a.length > 3 ? +a[3] : 255 };
  }

  function css(c) {
    return 'rgba(' + Math.round(c.r) + ',' + Math.round(c.g) + ',' +
           Math.round(c.b) + ',' + (c.a / 255) + ')';
  }

  /* ---------- instansen ---------- */
  function P5(sketch) {
    var p = this;
    var cnv = null, ctx = null, dpr = 1;
    var wantsLoop = true, onScreen = true, raf = null;
    var doFill = true, doStroke = false;
    var fillC = { r: 255, g: 255, b: 255, a: 255 };
    var strokeC = { r: 0, g: 0, b: 0, a: 255 };

    p.RGB = 'rgb';
    p.HSB = 'hsb';
    p.PI = Math.PI;
    p.TWO_PI = Math.PI * 2;
    p.width = 0;
    p.height = 0;
    p.frameCount = 0;

    function sizeTo(w, h) {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      p.width = w;
      p.height = h;
      cnv.width = Math.round(w * dpr);
      cnv.height = Math.round(h * dpr);
      cnv.style.width = w + 'px';
      cnv.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
    }

    p.createCanvas = function (w, h) {
      cnv = document.createElement('canvas');
      ctx = cnv.getContext('2d');
      sizeTo(w, h);
      watchVisibility();
      return {
        elt: cnv,
        parent: function (target) {
          var host = typeof target === 'string' ? document.getElementById(target) : target;
          (host || document.body).appendChild(cnv);
        }
      };
    };

    p.resizeCanvas = function (w, h) { sizeTo(w, h); };
    p.colorMode = function () {};       // kun RGB 255 bruges
    p.pixelDensity = function () {};
    p.frameRate = function () {};

    /* ---------- tegning ---------- */
    p.background = function () {
      var c = parseColor(arguments);
      ctx.save();
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.fillStyle = css(c);
      ctx.fillRect(0, 0, p.width, p.height);
      ctx.restore();
    };

    p.fill = function () { fillC = parseColor(arguments); doFill = true; };
    p.noFill = function () { doFill = false; };
    p.stroke = function () { strokeC = parseColor(arguments); doStroke = true; };
    p.noStroke = function () { doStroke = false; };
    p.strokeWeight = function (n) { ctx.lineWidth = n; };
    p.push = function () { ctx.save(); };
    p.pop = function () { ctx.restore(); };
    p.translate = function (x, y) { ctx.translate(x, y); };
    p.rotate = function (a) { ctx.rotate(a); };
    p.scale = function (x, y) { ctx.scale(x, y === undefined ? x : y); };

    function paint() {
      if (doFill) { ctx.fillStyle = css(fillC); ctx.fill(); }
      if (doStroke) { ctx.strokeStyle = css(strokeC); ctx.stroke(); }
    }

    p.rect = function (x, y, w, h) { ctx.beginPath(); ctx.rect(x, y, w, h); paint(); };
    p.circle = function (x, y, d) { ctx.beginPath(); ctx.arc(x, y, d / 2, 0, Math.PI * 2); paint(); };
    p.ellipse = function (x, y, w, h) {
      ctx.beginPath();
      ctx.ellipse(x, y, w / 2, (h === undefined ? w : h) / 2, 0, 0, Math.PI * 2);
      paint();
    };
    p.point = function (x, y) { ctx.beginPath(); ctx.arc(x, y, (ctx.lineWidth || 1) / 2, 0, Math.PI * 2); if (doStroke) { ctx.fillStyle = css(strokeC); ctx.fill(); } };
    p.line = function (x1, y1, x2, y2) {
      ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2);
      if (doStroke) { ctx.strokeStyle = css(strokeC); ctx.stroke(); }
    };

    /* ---------- matematik ---------- */
    p.random = function (a, b) {
      if (a === undefined) return Math.random();
      if (b === undefined) return Math.random() * a;
      return a + Math.random() * (b - a);
    };
    p.constrain = function (v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); };
    p.map = function (v, a, b, c, d) { return c + (d - c) * ((v - a) / (b - a)); };
    p.lerp = function (a, b, t) { return a + (b - a) * t; };
    p.dist = function (x1, y1, x2, y2) { var dx = x2 - x1, dy = y2 - y1; return Math.sqrt(dx * dx + dy * dy); };

    /* ---------- farve-API ---------- */
    p.color = function () { return parseColor(arguments); };
    p.red = function (c) { return c.r; };
    p.green = function (c) { return c.g; };
    p.blue = function (c) { return c.b; };
    p.alpha = function (c) { return c.a; };
    p.lerpColor = function (c1, c2, t) {
      t = t < 0 ? 0 : (t > 1 ? 1 : t);
      return {
        r: c1.r + (c2.r - c1.r) * t,
        g: c1.g + (c2.g - c1.g) * t,
        b: c1.b + (c2.b - c1.b) * t,
        a: c1.a + (c2.a - c1.a) * t
      };
    };

    /* ---------- loop ---------- */
    p.noLoop = function () { wantsLoop = false; };
    p.loop = function () { if (!wantsLoop) { wantsLoop = true; schedule(); } };
    p.redraw = function () { if (typeof p.draw === 'function') { p.frameCount++; p.draw(); } };

    function running() { return wantsLoop && onScreen; }

    function tick() {
      raf = null;
      if (typeof p.draw === 'function') { p.frameCount++; p.draw(); }
      schedule();
    }

    function schedule() {
      if (raf === null && running()) raf = window.requestAnimationFrame(tick);
    }

    // Stop naar animationen ikke er i billedet. Den rigtige p5 koerer videre,
    // ogsaa naar man for laengst har scrollet forbi.
    function watchVisibility() {
      if (!window.IntersectionObserver) return;
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen) schedule();
        else if (raf !== null) { window.cancelAnimationFrame(raf); raf = null; }
      }, { rootMargin: '120px' }).observe(cnv);
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) schedule();
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (typeof p.windowResized === 'function') p.windowResized();
      }, 150);
    });

    /* ---------- start ---------- */
    sketch(p);
    if (typeof p.setup === 'function') p.setup();
    if (typeof p.draw === 'function') {
      if (wantsLoop) schedule();
      else p.draw();                    // setup kaldte noLoop() — tegn ét billede
    }
  }

  window.p5 = P5;
})();
